import ExtraContent from "../../../../views/digibord/content/season/ExtraContent.vue";

export default [
  {
    path: "extra/",
    name: "ExtraContent",
    component: ExtraContent,
    meta: {
      containerClass: "showExtraContent",
    },
    children: [
      {
        path: ":seasonSlug/",
        name: "ExtraContentWithSeason",
        component: ExtraContent,
      },
    ],
  },
];
